<ion-header class="ion-no-border">
  <ion-toolbar>
    <ion-title>myPOS</ion-title>
    <ion-buttons slot="end">
      <ion-button
        fill="clear"
        (click)="handleCloseRequest()"
        [disabled]="isClosing || orderCreationActive || hasApprovedUnsavedPayment"
      >
        <ion-icon name="close-outline" slot="icon-only"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="terminal-state">
    <h2>myPOS Terminal</h2>
    <p class="amount">{{ dataPayload?.totalAmount | number:'1.2-2' }}</p>
    <p class="status-label">Reader</p>
    <p class="status-value">{{ readerStatus }}</p>
    <p class="status-label">Payment</p>
    <p class="status-value">{{ paymentStatus }}</p>

    <ion-spinner *ngIf="loading" name="crescent"></ion-spinner>

    <ion-note color="danger" *ngIf="errorLog">{{ errorLog }}</ion-note>
  </div>
</ion-content>

<ion-footer class="ion-no-border">
  <ion-toolbar>
    <ion-button
      expand="block"
      fill="clear"
      (click)="handlePrimaryAction()"
      [disabled]="isClosing || orderCreationActive || terminalCancelRequested"
    >
      {{ closeButtonText }}
    </ion-button>
  </ion-toolbar>
</ion-footer>
